/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: FavoriteSectionPlaceholder.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  28.10.22 12:44 pm.
 * Last modified: 28.10.22 12:44 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';
import { FAVORITE_SECTION_NAME } from '../constants';
import { useSettings } from '../contexts/SettingsContext';
import { useTranslator } from '../contexts/TranslatorContext';

const FavoriteSectionPlaceholder = () => {
    const [{ host, mode }] = useSettings();
    const translate = useTranslator();

    return (
        <div className="egt_favorite_section_placeholder">
            <div>
                {translate(
                    mode === 'desktop' ? 'DESKTOP.favouritesNoEntry' : 'favouritesNoEntry',
                    <img
                        src={addBuildHash(`${host}/assets/portal/ui/favoritesOff.svg`)}
                        alt=""
                        key={'favorite_section'}
                    />,
                    <b key={'favorite_section_translation'}>{translate(FAVORITE_SECTION_NAME)}</b>,
                )}
            </div>
        </div>
    );
};

export default FavoriteSectionPlaceholder;
